import React from 'react';
import { useState } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons'
import {	
	Col,
	Collapse,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Navbar,
	NavbarToggler,
	Nav,
	Row,
	UncontrolledDropdown,
} from 'reactstrap';
import { logoutUrl, userProfileUrl } from '../routes';
import './NavHeader.scss';

function NavHeader(props: any) {

	const {
		auth,
		isSso,
		logoUrl,
		routePrefix
	}: {
		auth: any,
		isSso: boolean,
		logoUrl: string,
		routePrefix: string
	} = props;

	const [isOpen, setIsOpen] = useState(false);

	const onToggle = (e: any) => {
		e.preventDefault();
		setIsOpen(!isOpen);
	};

	const showProfile = (auth: any) => {
		return auth.isAuthenticated ?
			<Navbar expand="md" dark>
				<NavbarToggler onClick={onToggle} />
				<Collapse isOpen={isOpen} navbar className="justify-content-end">
					<Nav>
						<UncontrolledDropdown nav inNavbar>
							<DropdownToggle nav className="dropdowntoggle-profile">
								<span className="profile-greeting">Hi {auth.firstName}!</span>
								<FontAwesomeIcon icon={faUserCircle} size="lg" className="profile-icon" />
							</DropdownToggle>
							<DropdownMenu end>
								{!isSso &&
									<LinkContainer to={userProfileUrl(routePrefix)}>
										<DropdownItem>
											Profile
										</DropdownItem>
									</LinkContainer>
								}
								{!isSso &&
									<DropdownItem divider />
								}
								<LinkContainer to={logoutUrl(routePrefix)}>
									<DropdownItem>
										Logout
									</DropdownItem>
								</LinkContainer>
							</DropdownMenu>
						</UncontrolledDropdown>
					</Nav>
				</Collapse>
			</Navbar>
			:
			""
	};

	return (
			<Row className="g-0 header-height align-items-center">
				<Col lg="2">
					<img src={logoUrl} alt="Header Logo" className="header-logo" />
				</Col>
				<Col lg="8" className="text-center"></Col>
				<Col lg="2" className="text-end">
						{showProfile(auth)}
				</Col>
			</Row>


		// <Row noGutters className="d-flex">
		// 	<Col lg="2"></Col>
		// 	<Col lg="8" className="text-center">
		// 		<img src="/resources/header-logo3.png" alt="Header Logo" />	
		// 	</Col>
		// 	<Col lg="2" className="align-items-center">
		// 			{showProfile(auth)}
		// 	</Col>
		// </Row>
	);
	
}

export default NavHeader;
